import { State } from 'src/redux/reducers/RootReducer';
import { postUploadImage } from 'src/apis/UploadAPI';
import { REACT_APP_BUCKET_NAME } from 'src/environments/environment';
import { setAlert } from 'src/redux/actions/alertActions';
import { ALERT_TYPE } from 'src/constants/AlertType';
import { setFormStatus } from 'src/redux/actions/formActions';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import { closeModal } from 'src/redux/actions/modalActions';
import { MODALS } from 'src/models/ModalModel';
import Debug from 'src/lib/Debug';
import makeApiRequest from 'src/lib/makeApiRequest';

export const uploadFileAction:
(
  file: string,
  path:string,
  mimeType: string,
  successmsg: string,
  errormsg: string,
  onUpload?: (path: string) => void,
) => ThunkedAction<State, boolean> =
  (
    file: string,
    path:string,
    mimeType: string,
    successmsg: string,
    errormsg: string,
    onUpload?: (path: string) => void,
  ) => async (dispatch: any, getState: any) => {
    const safeAtob = (base64String: string): Uint8Array => {
      try {
        // Remove any data URL prefix remnants and validate basic format
        const cleanBase64 = base64String.replace(/[^A-Za-z0-9+/=]/g, '');
        if (cleanBase64.length % 4 !== 0) {
          throw new Error('Invalid base64 length');
        }
        return Uint8Array.from(atob(cleanBase64), (char:string) => char.charCodeAt(0));
      } catch (err) {
        Debug.error(`Base64 decode failed: ${err}`);
        dispatch(setFormStatus({ [FORM.upload_image]: FORM_STATUS.error }));
        throw new Error('Invalid base64 data');
      }
    };

    try {
      const organisation = getState().currentOrganisation.id;
      const payload = {
        key: path,
        'content-type': mimeType,
        bucket: REACT_APP_BUCKET_NAME,
      };
      dispatch(setFormStatus({ [FORM.upload_image]: FORM_STATUS.processing }));
      // GET signed URL
      const response = await postUploadImage(organisation, payload);
      // If error log it and exit
      if (!response.success) {
        dispatch(setAlert({
          type: ALERT_TYPE.error,
          message: errormsg,
        }));
        dispatch(closeModal({ modal: MODALS.uploadImage }));
        dispatch(setFormStatus({ [FORM.upload_image]: FORM_STATUS.error }));
        return false;
      }
      // Push to S3
      // const base64Data = file.split(',')[1];
      const s3Result = await makeApiRequest({
        url: response.data.url, // Direct S3 signed URL
        external: true,
        method: 'PUT',
        data: safeAtob(file), // Binary data
        headers: {
          'Content-Type': mimeType,
        },
        organisation, // Your required param
      });
      // Everything OK
      if (s3Result.success) {
        dispatch(setFormStatus({ [FORM.upload_image]: FORM_STATUS.success }));
        dispatch(setAlert({
          type: ALERT_TYPE.success,
          message: successmsg,
        }));
        if (onUpload) {
          onUpload(path);
        }
        dispatch(closeModal({ modal: MODALS.uploadImage }));
        return true;
      }
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: errormsg,
      }));
      dispatch(setFormStatus({ [FORM.upload_image]: FORM_STATUS.error }));
      dispatch(closeModal({ modal: MODALS.uploadImage }));
      return false;
    } catch (e) { /* Log the error here */
      Debug.error(e);
      dispatch(setFormStatus({ [FORM.upload_image]: FORM_STATUS.error }));
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: errormsg,
      }));
      return false;
    }
  };
